import React, { Component } from 'react';
import { Form, Icon } from 'antd';
import clazz from 'classnames';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { UploadImg } from '@/components';
import styles from '../_style/img.less';
import styled from 'styled-components';
const UploadDiv = styled.div `
  width:120px;
  height:90px;
  box-sizing: border-box;
  .ant-upload.ant-upload-select-picture-card , .index_upload_img_container_qUSIT{
    width:100%;
    height:100%;
    .index_imgStyle_3xaHO{
      width:120px;
      height:90px;
    }
  }
  .ant-upload.ant-upload-select-picture-card{
    border-radius: 0;
  }
  .ant-upload-picture-card-wrapper{
    height:100%;
  }
`;
const mapStateToProps = (rootState) => ({
    session: rootState.session,
});
class SessionUploadImg extends Component {
    constructor(props) {
        super(props);
        this.uploadImg = null;
    }
    componentDidMount() {
        dispatch.session.getSessionImgList({});
    }
    changeImg(img) {
        const { roundPic, roundPicUpload } = this.props.session;
        const data = {
            roundPicUpload: img,
        };
        if (!img && (roundPic === roundPicUpload)) {
            data.roundPic = '';
            this.uploadImg = '';
        }
        else {
            data.roundPic = img;
            this.uploadImg = img;
        }
        dispatch.session.SET_STATE(Object.assign({}, data));
    }
    render() {
        const { roundPic, pageState, roundStatus, defaultImgList, roundPicUpload } = this.props.session;
        if (this.uploadImg === null && roundPicUpload !== '') {
            this.uploadImg = roundPicUpload;
        }
        return (<Form.Item required label={'选择场次图片或上传'}>
        <div style={{
            display: 'flex',
            marginLeft: 10,
        }}>
          <div className={styles.img_list}>
            {pageState !== 2 && roundStatus === 0 && defaultImgList.length > 0 && defaultImgList.slice(0, 5).map((imgSrc, index) => {
            return (<div className={clazz(styles.img_item, {
                [styles.item_checked]: roundPic === imgSrc,
            })} key={`default_${index}`} onClick={() => {
                if (roundPic === imgSrc) {
                    dispatch.session.SET_STATE({
                        roundPic: '',
                    });
                    return;
                }
                dispatch.session.SET_STATE({
                    roundPic: imgSrc,
                });
            }}>
                    {roundPic === imgSrc && (<div className={styles.checked}>
                          <Icon className={styles.checked_icon} type="check"/>
                        </div>)}
                    <div style={{
                width: '100%',
                height: '100%',
            }}>
                      <img className={styles.img} src={imgSrc} alt=""/>
                    </div>
                  </div>);
        })}
          </div>
          <div className={clazz(styles.img_item, {
            [styles.item_checked]: pageState !== 2 && roundStatus === 0 && (roundPic && roundPic === this.uploadImg),
        })} onClick={() => {
            setTimeout(() => {
                this.uploadImg !== '' && pageState !== 2 && roundStatus === 0 && dispatch.session.SET_STATE({
                    roundPic: this.uploadImg,
                });
            });
        }}>
            {pageState !== 2 && roundStatus === 0 && roundPic && roundPic === this.uploadImg && (<div className={styles.checked}>
                  <Icon className={styles.checked_icon} type="check"/>
                </div>)}
            <UploadDiv>
              <UploadImg imgUrl={(pageState === 2 && roundStatus !== 0) ? roundPic : roundPicUpload} isCanDel={pageState !== 2 && roundStatus === 0} changeImgUrl={(pic = '') => {
            this.changeImg(pic);
        }}/>
            </UploadDiv>
          </div>
        </div>
      </Form.Item>);
    }
}
export default connect(mapStateToProps)(SessionUploadImg);
